// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2nW3q","select":"Header_select__11Pcm","clinic":"Header_clinic__2Uy8e"};